class ManagedTesterTestStatusReportController {
    constructor($routeParams, $browser, $window, ReportUtilityServiceApi, ReportServiceApi, $uibModal, toastr, moment, UserDetailsApi, SettingsService, $location, ngProgressFactory, UserServiceApi, ProjectTestingServiceApi, ReportUtils, UtpSimServiceApi) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (changes.simId) {
                this.simId = changes.simId.currentValue;
            }
            if (changes.testerId) {
                this.testerId = changes.testerId.currentValue;
            }
        };
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.state = {
                    showSelectors: true,
                    canExport: true,
                    userDetails: null,
                    reportRequest: {
                        testerId: -1,
                        simId: -1
                    },
                    gridOptions: {},
                    DateFormats: {},
                    dialog: false,
                    isSupport: false,
                    showReport: false,
                    selectedSim: null,
                    selectedTester: null,
                    userPlaceholder: 'Select a tester',
                    userDropdownPopoverText: 'Testers with test results',
                    simPlaceholder: 'Select a Simulator',
                    simDropdownPopoverText: 'Tester simulators with test results',
                    showSpinner: false
                    // hideNav: _.startsWith($location.path(), '/Reports')
                };
                this.data = {
                    projectData: null,
                    testers: [],
                    testStatusReports: [],
                    simulators: []
                };
                // @ts-ignore: Report clashes with dom.lib.d.ts Report
                this.managedTesterCertificationReport = {
                    Id: 0,
                    Name: '',
                    Description: 'Tester Test Status Report',
                    Route: '',
                    Component: '',
                    Icon: '',
                    IsDeleted: false,
                    LastAmended: null,
                    LastAmendedBy: 0,
                    ReportOrder: 0,
                    IsExternal: false,
                    Filetype: '',
                    IdPId: ''
                };
                // Initialise progress bar
                this.traceProgress = this.ngProgressFactory.createInstance();
                this.showPopover = false;
                this.state.showReport = false;
                this.hide = true;
                this.state.reportRequest.simId = this.simId;
                this.state.reportRequest.testerId = this.testerId;
                // If the user has a predetermined simId then dont show them options
                if (this.state.reportRequest.simId > 0) {
                    this.state.showSelectors = false;
                    this.state.dialog = true;
                }
                // Hide report until we know wether we are using narrow or wide
                this.traceProgress.start();
                this.SettingsService.getCachedSettings().then((settings) => {
                    this.state.DateFormats = {
                        DateTimeFormat: settings.DateTimeFormat,
                        DateFormat: settings.DateFormat,
                        TimeFormat: settings.TimeFormat
                    };
                    this.columnDefs = [];
                    this.columnDefs.push({
                        headerName: 'Id',
                        field: 'Id',
                        width: 65,
                        minWidth: 65,
                        filter: 'number',
                        hide: this.hide
                    });
                    this.columnDefs.push({
                        headerName: 'simId',
                        field: 'simId',
                        width: 65,
                        minWidth: 65,
                        filter: 'number',
                        hide: this.hide
                    });
                    this.columnDefs.push({
                        headerName: 'Simulator',
                        field: 'SimName',
                        minWidth: 120,
                        hide: this.hide
                    });
                    this.columnDefs.push({
                        headerName: 'SuiteId',
                        field: 'SuiteId',
                        width: 65,
                        minWidth: 65,
                        filter: 'number',
                        hide: this.hide
                    });
                    this.columnDefs.push({
                        headerName: 'Test Suite',
                        field: 'SuiteName',
                        minWidth: 120,
                        sort: 'asc'
                    });
                    this.columnDefs.push({
                        headerName: 'TestId',
                        field: 'TestId',
                        width: 65,
                        minWidth: 65,
                        filter: 'number',
                        hide: this.hide
                    });
                    this.columnDefs.push({
                        headerName: 'Test Case',
                        field: 'TestName',
                        // width: 120,
                        minWidth: 120,
                        cellRenderer: this.caseCellRenderer
                    });
                    this.columnDefs.push({
                        headerName: 'Host Log',
                        field: 'HostLog',
                        width: 60,
                        minWidth: 60,
                        cellRenderer: this.hostLogRenderer,
                        sortable: false
                    });
                    this.columnDefs.push({
                        headerName: 'Card Log',
                        field: 'TerminalLog',
                        width: 60,
                        minWidth: 60,
                        cellRenderer: this.terminalLogRenderer,
                        sortable: false
                    });
                    if (settings.EnableReceipts) {
                        this.columnDefs.push({
                            headerName: 'Receipt',
                            field: 'Receipt',
                            width: 60,
                            minWidth: 60,
                            cellRenderer: this.ReceiptRenderer,
                            sortable: false
                        });
                    }
                    this.columnDefs.push({
                        headerName: 'xLog',
                        field: 'MasLog',
                        width: 60,
                        minWidth: 60,
                        cellRenderer: this.MasLogRenderer,
                        sortable: false
                    });
                    if (settings.EnableWaiversAndNotes) {
                        this.columnDefs.push({
                            headerName: 'Waiver',
                            field: 'WaiverGranted',
                            width: 60,
                            minWidth: 60,
                            cellRenderer: this.WaiverRenderer,
                            sortable: false
                        });
                    }
                    this.columnDefs.push({
                        headerName: 'Clearing',
                        field: 'Clearing',
                        width: 60,
                        minWidth: 60,
                        cellRenderer: this.ClearingValidationRenderer,
                        sortable: false
                    });
                    this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
                    this.rowCount = '';
                    this.state.showReport = true;
                });
                this.UserDetailsApi.get().then((response) => {
                    this.state.userDetails = response.data;
                    if (this.state.userDetails.IsProjectTester) {
                        this.state.userPlaceholder = 'Select a project';
                        this.state.userDropdownPopoverText = 'Projects with test results';
                        this.state.simDropdownPopoverText = 'Project simulators with test results';
                    }
                    if ((this.state.userDetails.IsTester || this.state.userDetails.IsGroupTester || this.state.userDetails.IsManagedTester) &&
                        this.state.reportRequest.testerId < 0) {
                        this.state.reportRequest.testerId = this.state.userDetails.Id;
                    }
                    else if (this.state.reportRequest.testerId < 0) {
                        this.state.isSupport =
                            this.state.userDetails.IsSupport ||
                                this.state.userDetails.IsProjectTester;
                    }
                    if (this.state.isSupport) {
                        let teamId = this.state.userDetails.Team === null
                            ? 0
                            : this.state.userDetails.Team.Id;
                        this.ReportServiceApi.getAllTestersWithTestProjects().then((testerLookupResponse) => {
                            this.data.testers = testerLookupResponse.data;
                            if (this.data.testers.length > 1) {
                                // @ts-ignore lodesh
                                let uniqueTesters = _.uniqBy(this.data.testers, (item) => { return item.Id; });
                                this.data.testers = _.sortBy(uniqueTesters, ['DisplayName']);
                            }
                            this.traceProgress.complete();
                            this.gridOptions.api.setRowData([]);
                            this.gridOptions.api.sizeColumnsToFit();
                            if (this.data.testers.length < 1) {
                                this.toastr.info('You have no testers to view.');
                            }
                        });
                    }
                    else {
                        this.getSimulators();
                        if (this.state.reportRequest.simId > 0) {
                            this.getReport();
                        }
                        else {
                            this.traceProgress.complete();
                            if (this.gridOptions.api !== undefined) {
                                this.gridOptions.api.setRowData([]);
                                this.gridOptions.api.sizeColumnsToFit();
                            }
                        }
                    }
                }, () => {
                    this.traceProgress.complete();
                    this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                    this.window.location.href =
                        this.browser.baseHref() + 'account/login';
                    return;
                });
                this.traceProgress.complete();
                this.ReportServiceApi.getReportByName('ManagedTesterCertificationReport').then((response) => {
                    if (Object.keys(response.data).length > 0) {
                        this.managedTesterCertificationReport = response.data;
                    }
                    else {
                        this.toastr.warning('Report descriptions not found');
                    }
                });
                this.isInitialized = true;
            }
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.hostLogRenderer = (row) => {
            return this.attributeRenderer((row.data), 'HostLog');
        };
        this.terminalLogRenderer = (row) => {
            return this.attributeRenderer((row.data), 'TerminalLog');
        };
        this.ReceiptRenderer = (row) => {
            return this.attributeRenderer((row.data), 'Receipt');
        };
        this.MasLogRenderer = (row) => {
            return this.attributeRenderer((row.data), 'MasLog');
        };
        this.WaiverRenderer = (row) => {
            return this.attributeRenderer((row.data), 'Waiver');
        };
        this.ClearingValidationRenderer = (row) => {
            return this.attributeRenderer((row.data), 'Clearing');
        };
        this.attributeRenderer = (row, component) => {
            const empty = '';
            const required = '<i class="fa fa-circle-o fa-lg text-muted" title="';
            const completed = '<i class="fa fa-circle fa-lg" title="';
            const failed = '<i class="fa fa-times-circle fa-lg" title="';
            const endStr = '"></i>';
            if (component === 'HostLog') {
                if (!row.Status.HostLogRequired)
                    return empty;
                if (row.Status.HostLogOk)
                    return (completed + 'HostLog required and completed OK.' + endStr);
                return required + 'Host Log required but not completed.' + endStr;
            }
            if (component === 'TerminalLog') {
                if (!row.Status.TerminalLogRequired)
                    return empty;
                if (row.Status.TerminalLogOk)
                    return (completed +
                        'Terminal Log required and completed OK.' +
                        endStr);
                return (required + 'Terminal Log required but not completed.' + endStr);
            }
            if (component === 'Receipt') {
                if (!row.Status.ReceiptRequired)
                    return empty;
                if (row.Status.ReceiptOk)
                    return (completed + 'Receipt required and completed OK.' + endStr);
                return required + 'Receipt required but not completed.' + endStr;
            }
            if (component === 'MasLog') {
                if (!row.Status.MasLogRequired)
                    return empty;
                if (row.Status.MasLogOk)
                    return (completed + 'MAS Log required and completed OK.' + endStr);
                return required + 'MAS Log required but not completed.' + endStr;
            }
            if (component === 'Clearing') {
                if (!row.Status.ClearingRequired) {
                    return empty;
                }
                if (row.Status.ClearingAttempted) {
                    if (row.Status.ClearingOk) {
                        return completed + 'Clearing required and completed OK.' + endStr;
                    }
                    return failed + 'Clearing required but validation has failed' + endStr;
                }
                else {
                    return required + 'Clearing required but not completed.' + endStr;
                }
            }
            if (component === 'Waiver') {
                if (row.Status.WaiverGranted)
                    return completed + 'Waiver granted.' + endStr;
                return empty;
            }
            return empty;
        };
        this.autoSizeAll = () => {
            let allColumnIds = [];
            if (this.columnDefs === undefined || this.columnDefs === null) {
                this.columnDefs = this.gridOptions.columnDefs;
            }
            this.columnDefs.forEach((columnDef) => {
                allColumnIds.push(columnDef.field);
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
            this.autoSizeAll();
        };
        this.getSimulators = () => {
            this.UtpSimServiceApi.getAllSimulators(this.state.reportRequest.testerId, false, false, true, false)
                .then((simResponse) => {
                let activeSims = simResponse.data;
                let sims = activeSims.activeSimulatorsList;
                if (_.isNil(sims) || sims.length === 0) {
                    this.data.simulators = [{ Id: 0, Name: 'No Simulators' }];
                }
                else {
                    this.data.simulators = _.map(sims, (item) => {
                        return {
                            Id: item.Id,
                            Name: item.SimName
                        };
                    });
                }
            });
        };
        this.selectTester = (tester) => {
            this.showPopover = false;
            if (!angular.isUndefined(tester)) {
                this.state.reportRequest.testerId = -1;
                this.state.reportRequest.simId = -1;
                this.state.selectedSim = undefined;
                this.data.simulators = undefined;
                this.state.reportRequest.testerId = tester.Id;
                this.data.projectData = null;
                this.gridOptions.api.setRowData([]);
                this.getSimulators();
            }
            else {
                this.state.reportRequest.testerId = -1;
                this.state.reportRequest.simId = -1;
                this.state.selectedSim = undefined;
                this.data.simulators = undefined;
                this.data.projectData = null;
                this.gridOptions.api.setRowData([]);
            }
        };
        this.selectSim = (sim) => {
            if (!angular.isUndefined(sim)) {
                this.state.reportRequest.simId = sim.Id;
                this.getData();
                this.getReport();
            }
            else {
                this.state.reportRequest.simId = -1;
                this.data.projectData = null;
                this.gridOptions.api.setRowData([]);
            }
        };
        this.getData = () => {
            this.ProjectTestingServiceApi.getProject(this.state.reportRequest.testerId, this.state.reportRequest.simId).then((projectDataResponse) => {
                this.data.projectData = projectDataResponse.data.ProjectConfigFields;
            });
        };
        this.getReport = () => {
            this.traceProgress.start();
            // Handle Odd Edge Cases and display nothing, don't display spinner forever! Could load a toastr here..
            if (this.state.reportRequest.testerId === undefined ||
                this.state.reportRequest.simId === undefined) {
                console.debug('Error - undefined component in this.state.reportRequest');
                this.gridOptions.api.setRowData([]);
                this.traceProgress.complete();
                this.gridOptions.api.sizeColumnsToFit();
                return;
            }
            this.state.showSpinner = true;
            this.ReportServiceApi.getTesterTestStatusReport(this.state.reportRequest.testerId, this.state.reportRequest.simId).then((response) => {
                this.data.testStatusReports = response.data;
                _.forEach(this.data.testStatusReports, (report) => {
                    report = this.generateReportStatus(report);
                });
                this.gridOptions.api.setRowData(this.data.testStatusReports);
                this.gridOptions.api.sizeColumnsToFit();
                this.traceProgress.complete();
                this.state.showSpinner = false;
            });
        };
        this.generateReportStatus = (report) => {
            const requiredComplete = 'Required - Complete';
            const requiredNotRun = 'Required - Not Run';
            const notRequired = 'Not Required';
            const complete = 'Complete';
            const status = report.Status;
            // TODO - re-work this when componentising - we are extending the data
            // object returned by the query
            // if there is a waiver in place then surely nothing is 'required'?
            report.HostLog = notRequired;
            if (status.HostLogMissing)
                report.HostLog = requiredNotRun;
            if (status.HostLogOk)
                report.HostLog = requiredComplete;
            report.Receipt = notRequired;
            if (status.ReceiptMissing)
                report.Receipt = requiredNotRun;
            if (status.ReceiptOk)
                report.Receipt = requiredComplete;
            report.TerminalLog = notRequired;
            if (status.TerminalLogMissing)
                report.TerminalLog = requiredNotRun;
            if (status.TerminalLogOk)
                report.TerminalLog = requiredComplete;
            report.MasLog = notRequired;
            if (status.MasLogMissing)
                report.MasLog = requiredNotRun;
            if (status.MasLogOk)
                report.MasLog = requiredComplete;
            report.Clearing = notRequired;
            if (status.ClearingMissing)
                report.Clearing = requiredNotRun;
            if (status.ClearingOk)
                report.Clearing = requiredComplete;
            report.WaiverGranted = notRequired;
            if (status.WaiverGranted)
                report.WaiverGranted = complete;
            return report;
        };
        this.exportCsv = () => {
            this.traceProgress.start();
            let projectName = 'Unnamed Project';
            this.ProjectTestingServiceApi.
                getProject(this.state.reportRequest.testerId, this.state.reportRequest.simId).
                then((response) => {
                let projectInfo = response.data;
                projectName = projectInfo.Name;
                const title = [
                    projectName,
                    ' ',
                    '- ' + this.managedTesterCertificationReport.Description + '.csv'
                ].join('');
                const reportName = this.ReportService.addDateToTitle(title);
                let date = this.moment(new Date()).format(this.state.DateFormats.DateFormat);
                let time = this.moment(new Date()).format(this.state.DateFormats.TimeFormat);
                let params = {
                    allColumns: false,
                    fileName: reportName
                };
                this.gridOptions.api.exportDataAsCsv(params);
                this.traceProgress.complete();
            });
        };
        this.caseCellRenderer = (row) => {
            return this.createCell(row.data.TruncatedTestName, row.data.TestName);
        };
        this.createCell = (data, tooltip) => {
            let cell = [
                '<span title="',
                tooltip,
                '">',
                data,
                '</span>'
            ].join(' ');
            return cell;
        };
        this.routeParams = $routeParams;
        this.browser = $browser;
        this.window = $window;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.uibModal = $uibModal;
        this.toastr = toastr;
        this.moment = moment;
        this.UserDetailsApi = UserDetailsApi;
        this.SettingsService = SettingsService;
        this.location = $location;
        this.ngProgressFactory = ngProgressFactory;
        this.UserServiceApi = UserServiceApi;
        this.ReportUtils = ReportUtils;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
    }
}
angular.module('app').component('managedTesterTestStatusReport', {
    templateUrl: 'Scripts/App/partials/Reports/managed-tester-test-status-report.tpl.html',
    bindings: {
        simId: '<',
        testerId: '<'
    },
    controllerAs: 'vm',
    controller: ManagedTesterTestStatusReportController
});
